import { useEffect, useState } from "react";
import {
  ServiceOutFilterServiceOut,
  ServiceOutDeleteServiceOut,
} from "../../Api/Services";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import { confirmAlert } from "react-confirm-alert";
import imgPlus from "../../assets/Icon/pluse.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function ServiceOut() {
  const [Data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const navigate = useNavigate();

  const start = async () => {
    try {
      const ServiceOutFilterServiceOutData = await ServiceOutFilterServiceOut(
        {},
      );
      if (
        ServiceOutFilterServiceOutData.status &&
        ServiceOutFilterServiceOutData.status === 200
      ) {
        setData(ServiceOutFilterServiceOutData.data.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف ",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      const ServiceOutDeleteServiceOutData =
        await ServiceOutDeleteServiceOut(e);
      if (
        ServiceOutDeleteServiceOutData.status &&
        ServiceOutDeleteServiceOutData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const Add = () => {
    navigate("/Panel/ServiceOut/Add");
  };

  const Edite = (id) => {
    navigate("/Panel/ServiceOut/Edite/" + id);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex justify-content-start align-items-center w-100 mb-5 pointer">
            <img
              onClick={() => {
                Add();
              }}
              src={imgPlus}
              alt=""
            />
          </div>
          <div className="d-flex justify-content-center align-items-center w-100 p-2 tableC">
            <table className="table">
              <thead className="sticky-header">
                <tr className="trTable">
                  <th>Name</th>
                  <th>UserName</th>
                  <th>Pass</th>
                  <th>Token</th>
                  <th>Address</th>
                  <th>DataConection1</th>
                  <th>DataConection2</th>
                  <th>DataConection3</th>
                  <th>DataConection4</th>
                  <th>DataConection5</th>
                  <th>DataConection6</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {Data.map((item, key) => (
                  <tr key={key}>
                    <td>{item.name}</td>
                    <td>{item.userName}</td>
                    <td>{item.pass}</td>
                    <td>{item.token}</td>
                    <td>{item.address}</td>
                    <td>{item.dataConection1}</td>
                    <td>{item.dataConection2}</td>
                    <td>{item.dataConection3}</td>
                    <td>{item.dataConection4}</td>
                    <td>{item.dataConection5}</td>
                    <td>{item.dataConection6}</td>

                    <td className="td-actions">
                      <span
                        className="d-inline-block pointer ms-2"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="حذف"
                      >
                        <img
                          height="30"
                          className="me-2"
                          src={imgDelete}
                          alt="حذف"
                          onClick={() => {
                            confirmDelete(item.id);
                          }}
                        />
                      </span>
                      <span
                        className="d-inline-block pointer"
                        tabIndex="0"
                        data-bs-toggle="tooltip"
                        title="ویرایش"
                      >
                        <img
                          height="30"
                          src={imgDoc}
                          alt="ویرایش"
                          onClick={() => {
                            Edite(item.id);
                          }}
                        />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceOut;
